import React, { Component } from 'react';

import './aboutme.css';
import '../App.css'

import bunny from './Kuvat/glenda.jpeg';

class Aboutme extends Component {
    render() {
        return (
            <div className = "aboutme-grid">
               <div className="aboutme-banner">
                <img
                src={bunny}
                alt="profphoto"
                className="profile-img"
                />

                    <h2>About Me</h2>
                    <p>
                        I'm a Mathematical information technology student interested in
                        programming and mathematics. On my freetime I enjoy working on a variety of
                        challenges and problems like visualization of algorithms or
                        learning about Web developing.
                    </p>
                    <p>
                        severi.nattila@gmail.com
                    </p>

               </div>
            </div>
        )
    }
}

export default Aboutme;